import { Component } from '@angular/core';
import {TranslatePipe} from "@ngx-translate/core";

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [
    TranslatePipe
  ],
  template: `
    <footer class="footer">
      <ul class="text-blue-general">
        <li class="cursor-pointer">
          <p class="text-blue-general">{{ 'components.app-public-layout.privacidad' | translate }}</p>
        </li>
        <li class="cursor-pointer">
          <p class="text-blue-general">{{ 'components.app-public-layout.condiciones' | translate }}</p>
        </li>
        <li class="cursor-pointer">
          <p class="text-blue-general">{{ 'components.app-public-layout.acerca-de' | translate }}</p>
        </li>
      </ul>
      <div class="text-center principal-text">
        <p>{{'components.app-footer.principal-text' | translate}}</p>
        <p>{{'components.app-footer.secondary-text' | translate}}</p>
      </div>
      <div>
        <img src="../../../../assets/img/icons-principal/logo-sitiapp.png"
             alt="logo-sitiapp" class="logo-sitiapp" draggable="false"/>
      </div>
    </footer>
  `,
  styles: `
    .footer {
      padding-block: 0.2rem 1rem;
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      //border-top: 0.5px solid var(--gray-200);

      ul {
        display: flex;
        flex-direction: row;
        padding-left: 0;
        gap: 1.7rem;
        justify-content: end;
        margin: 0.1rem;

       :first-child{
         list-style: none;
       }
        li::marker {
          font-size: 10px;
        }
      }
    }

    .principal-text {
      color: #707070;
      font-size: 12px;
      margin-block: 0 1rem;

      p {
        margin-block: 0 0.2rem;
      }

    }

    .logo-sitiapp {
      $size: 1.3rem;
      filter: contrast(0.5);
      width: $size;
      height: $size;
    }

  `
})
export class FooterComponent {

}
